import EnterpriseDetail from './EnterpriseDetail';

export default EnterpriseDetail;
